import React from 'react';
import { translate } from 'react-translate';
import Textblock from '../Components/Textblock';

const MassInfo = (props) => {
  return (
    <div className="mass-info">
        <h2 className="mass-info-heading">Modlitby</h2>
        <div className="mass-info-content">
            <Textblock codename="modlitby" language={props.language} />
        </div>
    </div>
  )
}

export default translate("PrayerInfo")(MassInfo);